// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#questionEditor[data-v-12c55f48]{height:10rem}", ""]);
// Exports
module.exports = exports;
